import { render } from "./AllBiochemistryTemplates.vue?vue&type=template&id=0afb4587"
import script from "./AllBiochemistryTemplates.vue?vue&type=script&lang=js"
export * from "./AllBiochemistryTemplates.vue?vue&type=script&lang=js"

import "./AllBiochemistryTemplates.vue?vue&type=style&index=0&id=0afb4587&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__